import React, {useState} from "react";
import {
  Footer as RCLFooter,
  FooterLink,
  FooterSocialLink
} from "discover.medical.react-component-library";

import dmxLogo from "../../assets/logo-ebsco-health-dmx.png";
import defaultLogo from "../../assets/logo-ebsco-health.png";

import TermsOfUse from "../termsOfUse";
import "./index.css";

export const Footer = ({ footerLinks, socialLinks, config, productName, onManageCookies }) => {
  const [isOpen, setIsOpen] = useState(false);

  const openTermsOfUseModal = (event) => {
    // If Terms & Condition link (which is at https://resources.ebsco.zone/ebsco-policies/terms-of-use.md) pop up dialog to display
    var target = event ? event?.target?.href : window.event?.srcElement?.href;
    if (target.indexOf("ebsco-policies") >= 0) {
      event.preventDefault();
      event.stopPropagation();
      setIsOpen(true);
    }
  };

  const closeTermsOfUseModal = () => {
    setIsOpen(false);
  }

  const footerLogo = productName === "dmx"
    ? dmxLogo
    : defaultLogo;

  const footerLogoClassName = productName === "dmx"
    ? "Footer__logo--dmx"
    : "Footer__logo";

  const currentYear = new Date().getFullYear();

  return (
    <>
      <RCLFooter
          copyright={`© ${currentYear} EBSCO Industries, Inc. All rights reserved`}
          links={footerLinks?.map((link) =>
                !link.cookiesLink || onManageCookies ? (
                    <FooterLink
                        key={link.url}
                        data-testid="footer-links"
                        href={link.url}
                        onClick={link.cookiesLink ? onManageCookies : openTermsOfUseModal}
                    >
                      {link.text}
                    </FooterLink>
                ) : null
            )
          }
          socialLinks={socialLinks?.map((link) => (
              <FooterSocialLink
                  key={link.url}
                  data-testid="footer-social-links"
                  glyph={link.name}
                  href={link.url}
              />
          ))}
          logo={<img alt="Ebsco Health" src={footerLogo} className={footerLogoClassName}/>}
      />
      <TermsOfUse isDlgOpen={isOpen} onClose={closeTermsOfUseModal} resourceUrl={config?.resourceURL}></TermsOfUse>
    </>
  );
};

export default Footer;
